module.exports = __webpack_public_path__ + "img/logo_consorcio.73337f17.png";